import React from 'react';
import styled from 'styled-components';
import { DefaultItem, DropdownSelect, Item } from '../../../gui/input/Select/DropdownSelect';
import usflag from '../../../../media/img/us-flag.png';
import { WhistlawLogoSvg } from '../../../../App/theme/WhistlawLogoSvg';
import { CompanyLogo } from './CompanyLogo';

const StyledHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  max-width: 780px;
  margin: auto;
  /* margin-top: 4rem; */
  height: 15vh;
  align-items:center;
`;

export const Header = () => {
  return (
    <StyledHeader className='reporting-header'>
      {/* <svg width="149" height="56" viewBox="0 0 149 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M78.2585 19.19C77.0099 18.1413 74.8788 17.6176 71.8641 17.6176H65.0646V38.6006H70.1489V32.0243H72.4264C75.1907 32.0243 77.2178 31.4168 78.5077 30.2006C79.9607 28.8381 80.692 27.0239 80.692 24.759C80.692 22.4104 79.8804 20.5537 78.2585 19.19ZM72.3 27.2763H70.1489V22.3656H72.0815C74.4323 22.3656 75.6077 23.1889 75.6077 24.8357C75.6077 26.4612 74.5043 27.2751 72.3 27.2751V27.2763ZM89.3922 17.6164H84.0905V38.5995H95.5373V33.8503H89.3922V17.6164ZM105.924 17.6164L97.5963 38.5995H103.304L104.396 35.549H111.632L112.631 38.5995H118.402L110.133 17.6164H105.924ZM105.862 31.3012L108.046 24.1291L110.196 31.3012H105.861H105.862ZM121.051 38.5995H126.354V17.6164H121.051V38.5995ZM146.941 21.5493C146.272 20.5794 145.412 19.7555 144.413 19.1275C142.813 18.1201 140.629 17.6176 137.863 17.6176H130.877V38.5995H139.049C142.002 38.5995 144.372 37.6357 146.161 35.7059C147.949 33.7772 148.842 31.2174 148.842 28.0289C148.842 25.4927 148.208 23.3328 146.94 21.5493H146.941ZM138.456 33.8491H136.18V22.3667H138.488C140.11 22.3667 141.356 22.874 142.23 23.8849C143.105 24.8958 143.542 26.3303 143.542 28.187C143.542 31.9617 141.846 33.8491 138.456 33.8491ZM22.0158 0L4.8315 4.49434L0.095685 21.751L6.0187 27.8236L0 33.7961L4.45703 51.1282L21.5669 55.9021L27.5868 49.9285L33.5098 56L50.6941 51.5057L55.4288 34.2478L49.5069 28.1775L55.5256 22.2051L51.0686 4.87182L33.9564 0.0979083L27.9388 6.07031L22.0158 0ZM11.4704 7.81379L20.5227 5.44512L24.4812 9.503L18.7082 15.2312L11.4704 7.81379ZM31.3421 9.55726L35.3645 5.56662L44.3777 8.08156L37.0218 15.3799L31.3421 9.55726ZM5.51901 20.3343L8.01273 11.2453L15.2482 18.6627L9.47636 24.391L5.51901 20.3331V20.3343ZM40.4228 18.868L47.7787 11.5673L50.1247 20.6976L46.1036 24.6894L40.4228 18.868ZM22.1103 18.7182L27.8833 12.99L33.5618 18.8125L27.79 24.5408L22.1103 18.7182ZM12.8797 27.8779L18.6515 22.1497L24.3335 27.9723L18.5593 33.7005L12.8797 27.8779ZM31.1933 28.0277L36.9651 22.2995L42.6448 28.1221L36.8718 33.8503L31.1933 28.0277ZM5.39852 35.3024L9.42202 31.3094L15.1005 37.1332L7.74694 44.4303L5.39852 35.3024ZM21.9615 37.1875L27.7345 31.4592L33.4141 37.2818L27.6423 43.01L21.9615 37.1875ZM40.2739 37.3384L46.0469 31.6102L50.0054 35.6669L47.5129 44.7559L40.2739 37.3384ZM11.1479 47.9196L18.5026 40.619L24.1847 46.4416L20.1612 50.4346L11.1479 47.9184V47.9196ZM31.0445 46.497L36.8163 40.7688L44.0529 48.1874L35.0018 50.5549L31.0445 46.497Z"
          fill="#111111"
        />
      </svg> */}
      <CompanyLogo width='8rem' height='8rem' borderRadius='0%' />
      {/*<WhistlawLogoSvg />*/}
      {/* <DropdownSelect width="220px" HeaderStyle="fill" defaultValue="CA">
        <DefaultItem>
          <img src={usflag} width="30px" />
          EN US
        </DefaultItem>
        <Item value="US">
          {' '}
          <img src={usflag} width="30px" />
          <span style={{ verticalAlign: 'super' }}>EN US</span>{' '}
        </Item>
        <Item value="CA">
          <img src={usflag} width="30px" />
          <span style={{ verticalAlign: 'super' }}>EN CA</span>{' '}
        </Item>
      </DropdownSelect> */}
    </StyledHeader>
  );
};
